import { InputCapture, captureStore } from '@playcastdotio/InputCapture';

export const Capture = () => {
  captureStore.updateAccess({
    mouse: false,
    keyboard: false,
    touch: true,
    gamepad: true,
  });
  return (
    <div className='absolute h-full w-full h-max-full w-max-full'>
      <div className='h-full w-full flex justify-start p-6'>
        <InputCapture showUi />
      </div>
    </div>
  );
};
